import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import {iniciaisNome} from './cadastroAtendimento.js';

/* Foto da pessoa; sem foto (ou sem nome), mostra as iniciais (ou o ícone padrão do Avatar). */
export default function FotoPessoa({urlFoto, nome}) {
    return (
        <Avatar src={urlFoto || undefined} alt={nome || undefined}>
            {iniciaisNome(nome) || undefined}
        </Avatar>
    );
}

FotoPessoa.propTypes = {
    urlFoto: PropTypes.string,
    nome: PropTypes.string
};
